angular.module('bmsApp.settings')
	.factory('MMJobRoomSvc', [
		'CRUDSvc',
		function (CRUDSvc) {

	return {
		index: function (params) {
			return CRUDSvc.get('api/mm/job/room/index', params);
		},
	}
}]);




